import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(5),
    overflowX: 'hidden',
  },
  paper: {
    padding: '2rem',
    marginTop: '1.5rem',
  },
  sectionTitle: {
    color: theme.palette.primary.main,
    fontSize: '18px',
    marginBottom: '10px',
    marginTop: '20px',
    fontWeight: 'bold',
  },
  // Precio: 4 campos en 2 filas de 2 columnas
  priceFieldsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
  // Producto: recorte a la izquierda y campos a la derecha; en pantallas
  // angostas la imagen queda arriba de los campos
  productLayout: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 2fr)',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
  // Producto: 8 campos en 2 columnas
  productFieldsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '16px',
    alignContent: 'start',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
  textField: {
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.87)',
      '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.87)',
    },
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '30px',
  },
  imageNavRow: {
    marginTop: '12px',
  },
  imageNavCounter: {
    minWidth: '80px',
    textAlign: 'center',
    fontSize: '14px',
    color: theme.palette.primary.gray,
  },
  productsTableWrapper: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
  },
  productsTableContainer: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    marginTop: '16px',
    overflowX: 'auto',
    backgroundColor: theme.palette.primary.white,
    border: `1px solid ${theme.palette.custom.hairline}`,
    borderRadius: '8px',
  },
  productsTable: {
    minWidth: '1200px',
  },
  productsTableHeader: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.primary.white,
  },
  productsTableRow: {
    cursor: 'pointer',
    '&.Mui-selected': {
      backgroundColor: theme.palette.custom.tableRowHover,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.custom.tableRowHover,
    },
  },
  productsTableCell: {
    whiteSpace: 'nowrap',
    fontSize: '12px',
  },
  productNavRow: {
    marginTop: '20px',
    marginBottom: '8px',
  },
  productNavCounter: {
    minWidth: '48px',
    textAlign: 'center',
    fontSize: '14px',
    color: theme.palette.primary.gray,
  },
  productImageBox: {
    minHeight: '200px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    backgroundColor: theme.palette.primary.white,
    padding: '16px',
  },
  productImage: {
    maxWidth: '100%',
    maxHeight: '200px',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
  },
  productGondolaImage: {
    maxWidth: '100%',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
  },
  // Loading superpuesto a la foto de góndola: al ir en absoluto no altera el
  // alto ni el ancho del recuadro mientras carga la imagen nueva
  gondolaImageLoader: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // Indicador de confianza de la IA (confidence_match), al lado del título
  // "Producto". Varía junto con el producto actual del carrusel. Se busca
  // que sea legible a simple vista pero discreto: color pálido, tamaño menor
  // al título, sin bordes ni fondo que llamen la atención.
  confidenceMatch: {
    marginLeft: '10px',
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.primary.gray,
  },
  confidenceMatchIcon: {
    marginRight: '4px',
    color: theme.palette.primary.gray,
  },
  // Foto referencial del producto (walmart_ai_products_catalog.s3ImageKey),
  // mostrada entre el título "Producto" y el formulario.
  productReferenceImageBox: {
    marginBottom: '16px',
  },
  productReferenceImage: {
    maxWidth: '100%',
    maxHeight: '180px',
    objectFit: 'contain',
    borderRadius: '8px',
    border: '1px solid #ddd',
  },
}));

export default useStyles;
